import { jsPDF } from "jspdf";
// import logoOC from '../../../logo/ocean_logo2.png';
import logoOC from '../../../logo/HD.jpg';
import ContainerPart from '../../../logo/containerParts.png';
import highpoint from '../../../logo/highpoint.png';
import { toDataURL } from '../../../Functions';
import { pageShort } from '../pdfFormat';
import { HeadCompose, HeadingCompose, VesselCompose, CommodityCompose, FinalCompose, } from './ATWContent';

import { CargoTransferSlipHeaDCompose, CargoTransferSlipHeadingCompose, CargoTransferSlipContentCompose, CargoTransferSlipClosingCompose, } from './CTSContent';

import { CBSHeaDCompose, CBSBodyOneCompose, CBSBodyTwoCompose, CBSBodyThreeCompose, CBSBodyFourCompose, CBSFinalCompose } from './CBSContent';

import { WBHeaDCompose, WBCustomerCompose, WBCargoCompose, WBGoodsCompose, WBChargeCompose, WBFinalCompose, } from './WBContent';

import { BUHeadCompose, BUBodyCompose, BUTableCompose, } from './BUContent';

import { LLHeadCompose, LLBodyCompose, LLTableCompose, LLRevisionCompose, } from './LLContent';

import { TallySheetHeaderCompose, TallySheetBodyCompose, TallySheetRemarkCompose, TallySheetTableCompose, } from './TSContent';

import { StowagePlanHeaderCompose, StowagePlanDataCompose, StowagePlanGridCompose } from './SPContent';

import { LCHeadCompose, LCBodyCompose, } from './LoadingConfirmationContent';

import { WBTruckHeadCompose, WBTruckBodyCompose, WBTruckFootCompose, } from './WBTruckerContent';

export function ATW(dataVal, exdata, user) {
    var ORGData = dataVal;
    var CurrentData = exdata;
    var CurrentUser = user;

    toDataURL(logoOC)
        .then(dataUrl => {
            var atw = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
            var rowL = pageShort.margin.top;

            atw.setProperties({
                title: 'Authorithy to Withdraw',
                subject: 'ATW',
                creator: 'OTGCI'
            });

            atw.setFont("courier", "normal");
            atw.setFontSize(11);

            rowL = HeadCompose(pageShort, rowL, atw, dataUrl, true);
            rowL = HeadingCompose(pageShort, rowL, atw, ORGData);
            rowL = VesselCompose(pageShort, rowL, atw, ORGData, CurrentData);
            rowL = CommodityCompose(pageShort, rowL, atw, ORGData);
            FinalCompose(pageShort, rowL, atw, ORGData, CurrentUser, CurrentData);

            atw.autoPrint();
            window.open(atw.output('bloburl'), '_blank');
        })
}

export function CTS(selectedData, user) {
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
            var rowL = pageShort.margin.top;

            dataDoc.setProperties({
                title: 'Cargo Transfer Slip',
                subject: 'CTS',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(11);
            dataDoc.setFont("times", "bold");
            rowL = CargoTransferSlipHeaDCompose(pageShort, rowL, dataDoc, dataUrl);
            rowL = CargoTransferSlipHeadingCompose(pageShort, rowL, dataDoc, selectedData);
            rowL = CargoTransferSlipContentCompose(pageShort, rowL, dataDoc, selectedData);
            CargoTransferSlipClosingCompose(pageShort, rowL, dataDoc, user);
            dataDoc.setFont("times", "normal");

            dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function CTSANDCBS(selectedData, user, booking, cyBranchAddress, printType, wbTrData) {
    var bookingData = booking;
    toDataURL(logoOC)
        .then(dataUrl => {
            toDataURL(ContainerPart)
            .then(containerURL => {
                toDataURL(highpoint)
                .then(HPURL => {
                    var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                    var rowL = pageShort.margin.top;
        
                    dataDoc.setProperties({
                        title: 'Cargo Transfer Slip And Cargo Booking Slip',
                        subject: 'CTS And CBS',
                        creator: 'OTGCI'
                    });
        
                    dataDoc.setFont("courier", "normal");
                    dataDoc.setFontSize(11);
                    rowL = CargoTransferSlipHeaDCompose(pageShort, rowL, dataDoc, dataUrl);
                    rowL = CargoTransferSlipHeadingCompose(pageShort, rowL, dataDoc, selectedData);
                    rowL = CargoTransferSlipContentCompose(pageShort, rowL, dataDoc, selectedData, containerURL);                
                    CargoTransferSlipClosingCompose(pageShort, rowL, dataDoc, user, selectedData);

                    if(printType === "CTSCBS"){
                        // dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                        // rowL = pageShort.margin.top;
                        var transaction;
                        let MOD = bookingData.find(d => d.modeOfDeliveryCode);
                        if (MOD.modeOfDeliveryCode === "DTD" || MOD.modeOfDeliveryCode === "DTP") {
                            transaction = "DOOR";
                        }
                        else if (MOD.modeOfDeliveryCode === "PTD" || MOD.modeOfDeliveryCode === "PTP") {
                            transaction = "PIER"
                        }
            
                        bookingData.forEach(element => {
                            dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                            rowL = pageShort.margin.top;

                            rowL = CBSHeaDCompose(pageShort, rowL, dataDoc, dataUrl, element, cyBranchAddress);
                            rowL = CBSBodyOneCompose(pageShort, rowL, dataDoc, element, transaction);
                            rowL = CBSBodyTwoCompose(pageShort, rowL, dataDoc, element, transaction, selectedData);
                            rowL = CBSBodyThreeCompose(pageShort, rowL, dataDoc, element);
                            if (transaction === "DOOR") {
                                rowL = CBSBodyFourCompose(pageShort, rowL, dataDoc, element);
                                if(rowL > 250){
                                    rowL = pageShort.margin.top;
                                    dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                                }
                                CBSFinalCompose(pageShort, rowL, dataDoc, selectedData, element, user);
                            }
                            else {
                                CBSFinalCompose(pageShort, rowL, dataDoc, selectedData, element, user);
                            }
                        });
                    
                    }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
        
                    if(wbTrData){
                        dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                        rowL = pageShort.margin.top;
                        dataDoc.setFontSize(10);
                        rowL = WBTruckHeadCompose(pageShort, rowL, dataDoc, wbTrData, HPURL);
                        rowL = WBTruckBodyCompose(pageShort, rowL, dataDoc, wbTrData);
                        WBTruckFootCompose(pageShort, rowL, dataDoc, wbTrData);
                    }
                    // dataDoc.autoPrint();
                    window.open(dataDoc.output('bloburl'), '_blank');
                });
            })
        })
}

export function CBS(user, booking, cyBranchAddress) {
    var bookingData = booking;
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
            var rowL = pageShort.margin.top;

            dataDoc.setProperties({
                    title: 'Cargo Booking Slip',
                    subject: 'CBS',
                    creator: 'OTGCI'
                });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(11);
            rowL = pageShort.margin.top;
            bookingData.forEach((element, id) => {
                var transaction;
                if (element.modeOfDeliveryCode === "DTD" || element.modeOfDeliveryCode === "DTP") {
                        transaction = "DOOR";
                }
                else if (element.modeOfDeliveryCode === "PTD" || element.modeOfDeliveryCode === "PTP") {
                        transaction = "PIER"
                }

                rowL = CBSHeaDCompose(pageShort, rowL, dataDoc, dataUrl, element, cyBranchAddress);
                rowL = CBSBodyOneCompose(pageShort, rowL, dataDoc, element, transaction);
                rowL = CBSBodyTwoCompose(pageShort, rowL, dataDoc, element, transaction);
                rowL = CBSBodyThreeCompose(pageShort, rowL, dataDoc, element);
                if (transaction === "DOOR") {
                        rowL = CBSBodyFourCompose(pageShort, rowL, dataDoc, element);
                }
                CBSFinalCompose(pageShort, rowL, dataDoc, null, element, user);

                if(bookingData.length > (id + 1)){
                    dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                    rowL = pageShort.margin.top;
                }
            });
    
            dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');
        })
}

export function WayBill(data, user, isWBCTS, ctsData, otherData, wbTrData) {
    // console.log(data)
    toDataURL(logoOC)
        .then(dataUrl => {
            toDataURL(ContainerPart)
            .then(containerURL => {
                toDataURL(highpoint)
                .then(HPURL => {

                    var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                    var rowL = pageShort.margin.top;

                    dataDoc.setProperties({
                        // title: 'WayBill',
                        // subject: 'WB',
                        title: 'WayBill and Cargo Tranfer Slip',
                        subject: 'WB CTS',
                        creator: 'OTGCI'
                    });

                    dataDoc.setFont("courier", "normal");
                    dataDoc.setFontSize(10);

                    if(user.isDat === false){
                        dataDoc.setTextColor(220);
                        dataDoc.setFontSize(200);
                        dataDoc.text('COPY', 60, 200, null, 45);
                        dataDoc.setFontSize(10);
                        dataDoc.setTextColor(0);
                    }

                    rowL = WBHeaDCompose(pageShort, rowL, dataDoc, dataUrl, data);
                    rowL = WBCustomerCompose(pageShort, rowL, dataDoc, data);
                    rowL = WBCargoCompose(pageShort, rowL, dataDoc, data);
                    rowL = WBGoodsCompose(pageShort, rowL, dataDoc, data);
                    if (data.showCharges) {
                        rowL = WBChargeCompose(pageShort, rowL, dataDoc, data);
                    }
                    WBFinalCompose(pageShort, rowL, dataDoc, data, user);
                    
                    if(otherData){
                        dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                        rowL = pageShort.margin.top;
                        dataDoc.setFontSize(11);
            
                        rowL = WBHeaDCompose(pageShort, rowL, dataDoc, dataUrl, otherData);
                        rowL = WBCustomerCompose(pageShort, rowL, dataDoc, otherData);
                        rowL = WBCargoCompose(pageShort, rowL, dataDoc, otherData);
                        rowL = WBGoodsCompose(pageShort, rowL, dataDoc, otherData);
                        if (otherData.showCharges) {
                            rowL = WBChargeCompose(pageShort, rowL, dataDoc, otherData);
                        }
                        WBFinalCompose(pageShort, rowL, dataDoc, otherData, user);
                    }

                    // CTS
                    if(isWBCTS && ctsData){
                        dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                        rowL = pageShort.margin.top;
                        dataDoc.setFontSize(11);
            
                        rowL = CargoTransferSlipHeaDCompose(pageShort, rowL, dataDoc, dataUrl);
                        rowL = CargoTransferSlipHeadingCompose(pageShort, rowL, dataDoc, ctsData);
                        rowL = CargoTransferSlipContentCompose(pageShort, rowL, dataDoc, ctsData, containerURL);                
                        CargoTransferSlipClosingCompose(pageShort, rowL, dataDoc, user, ctsData);
                    }
                    if(wbTrData && Object.keys(wbTrData).length !== 0){
                        dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                        rowL = pageShort.margin.top;
                        dataDoc.setFontSize(10);

                        rowL = WBTruckHeadCompose(pageShort, rowL, dataDoc, wbTrData, HPURL);
                        rowL = WBTruckBodyCompose(pageShort, rowL, dataDoc, wbTrData);
                        WBTruckFootCompose(pageShort, rowL, dataDoc, wbTrData);
                    }

                    dataDoc.autoPrint();
                    window.open(dataDoc.output('bloburl'), '_blank');
                })
            })
        })
}

export function BuildUp(data) {
    // console.log(data)
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layoutL, pageShort.papersize.unit, pageShort.papersize.format);
            var rowL = pageShort.margin.top;

            dataDoc.setProperties({
                title: 'Build-Up',
                subject: 'BU',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(10);

            rowL = BUHeadCompose(pageShort, rowL, dataDoc, dataUrl);
            rowL = BUBodyCompose(pageShort, rowL, dataDoc, data);
            BUTableCompose(pageShort, rowL, dataDoc, data);

            dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function LOADLIST(data) {
    // console.log(data)
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layoutL, pageShort.papersize.unit, pageShort.papersize.format);
            var rowL = pageShort.margin.top;

            dataDoc.setProperties({
                title: 'Load List',
                subject: 'LL',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(10);

            rowL = LLHeadCompose(pageShort, rowL, dataDoc, dataUrl);
            rowL = LLBodyCompose(pageShort, rowL, dataDoc, data);
            rowL = LLTableCompose(pageShort, rowL, dataDoc, data);
            if (data.revision && data.revision.length > 0) {
                rowL = pageShort.margin.top;
                dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                LLRevisionCompose(pageShort, rowL, dataDoc, data);
            }

            // dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function TallySheetPdf(type, details) {
    var header, detail, forTime;
    var categoryType;
    // console.log(details)
    if (type === 'read') {
        header = details.header[0];
        detail = details.tallySheetDetails;
        forTime = details.header[0];
        categoryType = 'one';
    }
    else {
        if (details.details.length === 1) {
            var tsT = details.details[0].tallySheetType;
            header = { ...details.header, tallySheetType: tsT };
            detail = details.details[0].details;
            forTime = details.details[0];
            categoryType = 'one';
        }
        else {
            var tsT2 = details.details[0].tallySheetType;
            header = { ...details.header, tallySheetType: tsT2 };
            forTime = details.details[0];
            categoryType = 'many';
        }
    }

    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
            var rowL = pageShort.margin.top;

            dataDoc.setProperties({
                title: 'Tally Sheet',
                subject: 'TS',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(10);

            if (categoryType === 'many') {
                details.details.forEach(element => {
                    rowL = pageShort.margin.top;
                    rowL = TallySheetHeaderCompose(pageShort, rowL, dataDoc, dataUrl);
                    rowL = TallySheetBodyCompose(pageShort, rowL, dataDoc, header, forTime);
                    // rowL = TallySheetRemarkCompose(pageShort, rowL, dataDoc, header);
                    rowL = TallySheetRemarkCompose(pageShort, rowL, dataDoc, details.finalTally);
                    TallySheetTableCompose(pageShort, rowL, dataDoc, element.details, header);

                    dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                });

                var pageCount = dataDoc.internal.getNumberOfPages();
                dataDoc.deletePage(pageCount)
            }
            else {
                rowL = TallySheetHeaderCompose(pageShort, rowL, dataDoc, dataUrl);
                rowL = TallySheetBodyCompose(pageShort, rowL, dataDoc, header, forTime);
                // rowL = TallySheetRemarkCompose(pageShort, rowL, dataDoc, header);
                rowL = TallySheetRemarkCompose(pageShort, rowL, dataDoc, details.finalTally);
                TallySheetTableCompose(pageShort, rowL, dataDoc, detail, header);
            }

            dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function StowagePlanPdf(data) {
    // console.log('data', data);
    var header = data.header[0];
    var detail = data.details;
    var template = data.template;

    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
            var rowL = pageShort.margin.top;

            dataDoc.setProperties({
                title: 'Stowage Plan',
                subject: 'SP',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(10);

            rowL = StowagePlanHeaderCompose(pageShort, rowL, dataDoc, dataUrl, header);
            rowL = StowagePlanGridCompose(pageShort, rowL, dataDoc, template, detail)
            if (detail && detail.length > 0) {
                StowagePlanDataCompose(pageShort, rowL, dataDoc, detail);
            }

            dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function loadingConfirmationPDF(data) {
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layoutL, pageShort.papersize.unit, pageShort.papersize.format);

            dataDoc.setProperties({
                title: 'Loading Confirmation',
                subject: 'LC',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(10);
            // console.log(data)
            data.forEach((element, i) => {
                var rowL = pageShort.margin.top;

                rowL = LCHeadCompose(pageShort, rowL, dataDoc, dataUrl);
                LCBodyCompose(pageShort, rowL, dataDoc, element, dataUrl);
                if ((i + 1) < data.length) {
                    dataDoc.addPage(pageShort.layoutL, pageShort.papersize.unit, pageShort.papersize.format);
                }
            });

            dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function TruckerWB(data) {
    toDataURL(highpoint)
    .then(HPURL => {
        var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                
        var rowL = pageShort.margin.top;
    
        dataDoc.setProperties({
            title: 'Truckers Waybill',
            subject: 'WB Trucker',
            creator: 'OTGCI'
        });
    
        dataDoc.setFont("courier", "normal");
        dataDoc.setFontSize(10);
    
        rowL = WBTruckHeadCompose(pageShort, rowL, dataDoc, data, HPURL);
        rowL = WBTruckBodyCompose(pageShort, rowL, dataDoc, data);
        WBTruckFootCompose(pageShort, rowL, dataDoc, data);
       
        window.open(dataDoc.output('bloburl'), '_blank');
    });
}